import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, get } from './constants';
import StyledOcticon from './StyledOcticon';
import sx from './sx';
import theme from './theme';
import isNumeric from './utils/isNumeric';
var variantSizes = {
  small: 56,
  medium: 96,
  large: 128
};
var sizeStyles = function sizeStyles(_ref) {
  var size = _ref.size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'medium' : _ref$variant;
  var calc = isNumeric(size) ? size : variantSizes[variant];
  return {
    width: calc,
    height: calc
  };
};
var CircleBadge = styled.div.withConfig({
  displayName: "CircleBadge",
  componentId: "sc-1lho816-0"
})(["display:", ";align-items:center;justify-content:center;background-color:", ";border-radius:50%;box-shadow:", ";", ";", ";", ";"], function (props) {
  return props.inline ? 'inline-flex' : 'flex';
}, get('colors.white'), get('shadows.medium'), COMMON, sizeStyles, sx);
var CircleBadgeIcon = styled(StyledOcticon).withConfig({
  displayName: "CircleBadge__CircleBadgeIcon",
  componentId: "sc-1lho816-1"
})(["height:auto;max-width:60%;max-height:55%;"]);
CircleBadge.defaultProps = {
  inline: false,
  theme: theme
};
CircleBadge.propTypes = _objectSpread(_objectSpread({
  inline: PropTypes.bool,
  size: PropTypes.number,
  theme: PropTypes.object,
  variant: PropTypes.oneOf(['small', 'medium', 'large'])
}, COMMON.propTypes), sx.propTypes);
CircleBadgeIcon.defaultProps = {
  theme: theme
};
CircleBadgeIcon.propTypes = _objectSpread({}, StyledOcticon.propTypes);
CircleBadgeIcon.displayName = 'CircleBadge.Icon';
export default Object.assign(CircleBadge, {
  Icon: CircleBadgeIcon
});